import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

export const SponsorFAQ = () => {
  const faqs = [
    {
      question: "How are donations processed?",
      answer: "All donations are processed in care of Sands Ltd., our registered partner in the Cayman Islands. This ensures secure handling and proper documentation for your sponsorship contribution."
    },
    {
      question: "Are sponsorship contributions tax-deductible?",
      answer: "Tax deductibility depends on your jurisdiction and tax situation. Sands Ltd. can provide receipts for your contribution, but we recommend consulting with your tax advisor for specific deductibility questions."
    },
    {
      question: "What is the CNCF Partnership Campaign?",
      answer: "Our CNCF (Cayman National Cultural Foundation) Partnership Campaign aims to expand Bobo & Teedee®'s reach globally while preserving and promoting Cayman Islands culture through educational entertainment."
    },
    {
      question: "How will my company be recognized?",
      answer: "Recognition varies by sponsorship tier and includes logo placement on materials, social media mentions, website acknowledgment, and potential custom episode features. Specific benefits are detailed in each tier."
    },
    {
      question: "Can I customize my sponsorship package?",
      answer: "Absolutely! While we offer standard tiers, we're happy to discuss custom sponsorship packages that align with your organization's goals and budget. Contact us to explore bespoke opportunities."
    },
    {
      question: "How do I track the impact of my sponsorship?",
      answer: "Sponsors receive regular impact reports showing viewership metrics, educational outcomes, and community engagement data. Heritage Guardian sponsors receive detailed annual impact reports."
    },
    {
      question: "What's the minimum sponsorship amount?",
      answer: "Our Island Ally tier starts at KYD 1,000, but we welcome discussions about smaller contributions or in-kind sponsorships that support our mission."
    },
    {
      question: "How long does the sponsorship commitment last?",
      answer: "Sponsorship terms are flexible and can range from single campaigns to annual partnerships. We'll work with you to find an arrangement that suits your organization's goals."
    },
    {
      question: "Can international companies sponsor Bobo & Teedee®?",
      answer: "Yes! We welcome international sponsors. Our banking details support international wire transfers, and we can work with your preferred payment methods."
    },
    {
      question: "What happens after I submit an inquiry?",
      answer: "We'll contact you within 1-2 business days to discuss your sponsorship goals, answer questions, and provide a detailed proposal tailored to your organization's needs."
    }
  ];

  return (
    <section className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <HelpCircle className="h-16 w-16 mx-auto mb-6 text-primary" />
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Get answers to common questions about sponsoring Bobo & Teedee®. 
            Don't see your question? Contact us directly.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-background rounded-lg shadow-sm border"
              >
                <AccordionTrigger className="text-left hover:no-underline px-6 py-4">
                  <span className="font-semibold">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="text-center mt-12">
            <div className="bg-background rounded-lg p-8 shadow-sm border">
              <h3 className="text-2xl font-bold mb-4">Still Have Questions?</h3>
              <p className="text-muted-foreground mb-6">
                Our team is here to help you find the perfect sponsorship opportunity
              </p>
              <div className="space-y-2">
                <p className="font-semibold">Contact Us:</p>
                <p>
                  <a href="mailto:contact@boboandteedee.com" className="text-primary hover:underline">
                    contact@boboandteedee.com
                  </a>
                </p>
                <p>
                  <a href="tel:+13459235116" className="text-primary hover:underline">
                    +1 (345) 923-5116
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};